import { render, staticRenderFns } from "./PinnedBtnContainer.vue?vue&type=template&id=32bacd37"
var script = {}
import style0 from "./PinnedBtnContainer.vue?vue&type=style&index=0&id=32bacd37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports